import { Fragment } from "react";
import { Switch, Route, Redirect, useLocation } from "react-router-dom";
import appInfo from "./app-info";
import routes from "./app-routes";
import { SideNavInnerToolbar as SideNavBarLayout } from "./layouts";
import { useSelector } from "react-redux";
import { getLocalizedMenu } from "./redux/localization";

export default function Content() {
  const location = useLocation();
  const strings = useSelector(getLocalizedMenu);
  return (
    <SideNavBarLayout title={appInfo.title}>
      <Switch>
        <Fragment>
          <h2 className={"content-block"}>
            {location.pathname.substr(1).length > 0
              ? strings.getString(location.pathname.substr(1))
              : ""}
          </h2>
          <div style={{ paddingInline: 40 }}>
            {routes.map(({ path, component }) => (
              <Route exact key={path} path={path} component={component} />
            ))}
          </div>
        </Fragment>
        <Redirect to={"/"} />
      </Switch>
      {/* <Footer>
        Copyright © 2011-{new Date().getFullYear()} {appInfo.title} Inc.
        <br />
        All trademarks or registered trademarks are property of their respective
        owners.
      </Footer> */}
    </SideNavBarLayout>
  );
}
